import { render, staticRenderFns } from "./keyan.vue?vue&type=template&id=5037f1ab&scoped=true&"
import script from "./keyan.vue?vue&type=script&lang=ts&"
export * from "./keyan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037f1ab",
  null
  
)

export default component.exports